<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col>
          <h1>
            <v-btn
              color="primary"
              x-small
              text
              @click="() => $router.push({ name: 'calendario-letivo' })"
            >
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            Painel Administrativo - Calendário Letivo {{ anoAtual }}
            <span class="meu-componente-especial">
              <e-help-tooltip
                :text="$constants.tooltips.calendarioLetivo.painelAdministrativo"
                :position="'bottom'"
              />
            </span>
          </h1>
        </v-col>
      </v-row>

      <v-container class="mt-5">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title class="text-center white--text" style="background-color: #fbbb14"
                >Legendas</v-card-title
              >

              <v-card-text>
                <v-row class="mt-1">
                  <v-col v-for="item in eventosList" :key="item.texto" cols="6" md="4">
                    <v-chip small :color="item.cor" class="ma-2" />
                    <span>{{ item.text }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-title>Eventos do Ano {{ anoAtual }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-data-table
                  v-if="eventos.length"
                  :headers="headers"
                  :items="eventosOrdenados"
                  item-key="start"
                >
                  <template v-slot:item.start="{ item }">
                    <span>{{ formatarData(item.start) }}</span>
                  </template>

                  <template v-slot:item.name="{ item }">
                    <div class="d-flex align-center">
                      <div
                        :style="{
                          backgroundColor: item.color,
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          marginRight: '8px',
                        }"
                      ></div>
                      <span>{{ item.name }}</span>
                    </div>
                  </template>

                  <template v-slot:item.descricao="{ item }">
                    <div class="d-flex align-center">
                      <span>{{ item.descricao }}</span>
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn
                      icon
                      small
                      color="blue"
                      @click="abrirModalEdicao(item)"
                      :disabled="
                        !$can(['calendarioLetivo.calendariosUpdate', 'calendarioLetivo.*'])
                      "
                    >
                      <v-icon>fa fa-edit</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="red"
                      @click="removerEvento(item)"
                      :disabled="
                        !$can(['calendarioLetivo.calendariosDelete', 'calendarioLetivo.*'])
                      "
                    >
                      <v-icon>fa fa-trash</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>

                <p v-else class="text-center">Nenhum evento cadastrado para este ano.</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="mt-5">
        <v-row>
          <v-col v-for="(mes, index) in meses" :key="index" cols="12" md="6" lg="4">
            <v-card>
              <v-card-title>{{ mes }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-calendar
                  ref="calendar"
                  :key="mes"
                  type="month"
                  :start="getFirstDayOfMonth(index)"
                  :events="getEventosDoMes(anoAtual, index)"
                  :show-adjacent-months="false"
                  class="calendario-fixo"
                  @click:date="onDateClick"
                  @click:event="abrirModalVisualizacao"
                  event-color="color"
                >
                </v-calendar>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <e-modal-add-evento
        :modal-aberto="modalAberto && !editando"
        :novo-evento="novoEvento"
        :eventos-list="eventosList"
        :loading="loading"
        @add-evento="addEvento"
        @fechar-modal="modalAberto = false"
      ></e-modal-add-evento>

      <e-modal-edit-evento
        :modal-aberto="modalAberto && editando"
        :novo-evento="novoEvento"
        :eventos-list="eventosList"
        :loading="loading"
        @editar-evento="editarEvento"
        @fechar-modal="modalAberto = false"
      ></e-modal-edit-evento>

      <e-modal-confirmar-evento
        :modal-confirmacao-aberto="modalConfirmacaoAberto"
        :evento-selecionado="eventoSelecionado"
        :loading="loading"
        @confirmar-remocao="confirmarRemocao"
        @fechar-modal="modalConfirmacaoAberto = false"
      ></e-modal-confirmar-evento>

      <e-modal-visualizar-evento
        :modal-aberto="modalVisualizarAberto"
        :evento-selecionado="eventoSelecionado"
        @fechar-modal="modalVisualizarAberto = false"
      ></e-modal-visualizar-evento>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import EModalAddEvento from "@/components//Calendario/EModalAddEvento.vue";
import EModalEditEvento from "@/components/Calendario/EModalEditEvento.vue";
import EModalConfirmarEvento from "@/components/Calendario/EModalConfirmarEvento.vue";

export default {
  components: {
    EModalAddEvento,
    EModalEditEvento,
    EModalConfirmarEvento,
  },
  data() {
    return {
      headers: [
        { text: "Categoria", align: "start", value: "name" },
        { text: "Evento", align: "start", value: "descricao" },
        { text: "Data", align: "start", value: "start" },
        { text: "Ação", align: "center", value: "action" },
      ],
      meses: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      eventosList: [],
      novoEvento: { data: null, evento_id: null, descricao: null },
      modalAberto: false,
      eventos: [],
      modalConfirmacaoAberto: false,
      eventoSelecionado: null,
      loading: false,
      editando: false,
      modalVisualizarAberto: false,
    };
  },
  mounted() {
    this.loadEventos();
    this.loadEventosCalendario();
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    anoAtual() {
      return this.user?.ano.descricao || new Date().getFullYear();
    },
    eventosOrdenados() {
      return this.eventos.slice().sort((a, b) => new Date(a.start) - new Date(b.start));
    },
    isFormValid() {
      return this.novoEvento.tipo && this.novoEvento.descricao;
    },
  },
  watch: {
    anoAtual(novoAno) {
      this.carregarEventos(novoAno);
    },
  },
  methods: {
    formatarData(data) {
      const date = new Date(data);
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
      return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "long" });
    },

    onDateClick(day) {
      const eventoExistente = this.eventos.find((e) => e.start === day.date);
      if (eventoExistente) {
        this.abrirModalVisualizacao({ event: eventoExistente });
        return;
      }

      if (this.$can(["calendarioLetivo.calendariosCreate", "calendarioLetivo.*"])) {
        this.abrirModalEvento(day);
      } else {
        this.$toast.danger("Você não tem permissão para criar eventos.");
      }
    },

    abrirModalConfirmacao(evento) {
      this.modalVisualizarAberto = false;
      this.modalAberto = false;
      this.editando = false;
      this.modalConfirmacaoAberto = false;
      this.eventoSelecionado = { ...evento, id: evento.id };
      this.modalConfirmacaoAberto = true;
    },

    async confirmarRemocao() {
      this.loading = true;
      try {
        await this.$services.calendarioLetivoService.removerEvento(this.eventoSelecionado.id);
        this.eventos = this.eventos.filter((e) => e.id !== this.eventoSelecionado.id);
        this.$toast.success("Evento removido com sucesso!");
      } catch (error) {
        this.$toast.error("Erro ao remover o evento.");
        this.$handleError(error);
      } finally {
        this.loading = false;
        this.modalConfirmacaoAberto = false;
        this.eventoSelecionado = null;
      }
    },

    async removerEvento(evento) {
      this.abrirModalConfirmacao(evento);
    },
    getFirstDayOfMonth(index) {
      return new Date(this.anoAtual, index, 1).toISOString().substr(0, 10);
    },

    abrirModalEvento(day) {
      this.modalVisualizarAberto = false;
      this.modalConfirmacaoAberto = false;
      this.modalAberto = false;
      this.editando = false;
      this.novoEvento = { data: day.date, evento_id: null, descricao: null };
      this.modalAberto = true;
      this.editando = false;
    },

    async abrirModalEdicao(evento) {
      this.modalVisualizarAberto = false;
      this.modalConfirmacaoAberto = false;
      this.modalAberto = false;
      this.editando = false;
      await this.loadEventos();

      this.novoEvento = {
        id: evento.id,
        data: evento.start,
        evento_id: evento.evento_id,
        descricao: evento.descricao,
      };
      this.modalAberto = true;
      this.editando = true;
    },

    async addEvento() {
      const eventoExistente = this.eventos.find((e) => e.start === this.novoEvento.data);

      if (eventoExistente) {
        this.$toast.danger("Não é permitido cadastrar mais de um evento na mesma data.");
        return;
      }

      const eventoSelecionado = this.eventosList.find((e) => e.id === this.novoEvento.evento_id);
      if (!eventoSelecionado) {
        this.$toast.error("Erro ao buscar os detalhes do evento.");
        return;
      }

      if (!eventoSelecionado) {
        this.$toast.danger("Erro ao buscar os detalhes do evento.");
        return;
      }

      const eventoParaSalvar = {
        evento_id: eventoSelecionado.id,
        name: eventoSelecionado.text,
        descricao: this.novoEvento.descricao,
        start: this.novoEvento.data,
        end: this.novoEvento.data,
        color: eventoSelecionado.cor,
        ano_id: this.user?.ano.id,
      };

      this.loading = true;
      try {
        const response = await this.$services.calendarioLetivoService.salvarCalendario(
          eventoParaSalvar
        );

        this.eventos.push({
          id: response.id,
          start: response.start,
          end: response.end,
          name: response.name,
          evento_id: response.evento_id,
          descricao: response.descricao,
          color: response.color,
        });

        this.$toast.success("Evento salvo com sucesso!");
      } catch (error) {
        this.$toast.error("Erro ao salvar o evento.");
        this.$handleError(error);
      } finally {
        this.loading = false;
        this.modalAberto = false;
        this.novoEvento = { data: null, evento_id: null, descricao: null };
      }
    },

    async editarEvento() {
      const eventoSelecionado = this.eventosList.find((e) => e.id === this.novoEvento.evento_id);

      if (!eventoSelecionado) {
        this.$toast.error("Erro ao buscar os detalhes do evento.");
        return;
      }

      const eventoParaSalvar = {
        id: this.novoEvento.id,
        evento_id: eventoSelecionado.id,
        name: eventoSelecionado.text,
        descricao: this.novoEvento.descricao,
        start: this.novoEvento.data,
        end: this.novoEvento.data,
        color: eventoSelecionado.cor,
        ano_id: this.user?.ano.id,
      };
      this.loading = true;
      try {
        await this.$services.calendarioLetivoService.atualizarEvento(eventoParaSalvar);
        const index = this.eventos.findIndex((e) => e.id === eventoParaSalvar.id);
        if (index !== -1) {
          this.eventos.splice(index, 1, eventoParaSalvar);
        }

        this.$toast.success("Evento editado com sucesso!");
      } catch (error) {
        this.$toast.error("Erro ao editar o evento.");
        this.$handleError(error);
      } finally {
        this.loading = false;
        this.modalAberto = false;
        this.novoEvento = { data: null, evento_id: null, descricao: null };
      }
    },

    getEventosDoMes(ano, index) {
      const mes = index;

      const eventosFiltrados = this.eventos.filter((evento) => {
        const eventoData = new Date(evento.start);
        const eventoMes = eventoData.getUTCMonth();
        return eventoMes === mes;
      });

      return eventosFiltrados.map((evento) => ({
        ...evento,
        color: evento.color || "#1976D2",
      }));
    },
    async loadEventosCalendario() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();

        this.eventos = response.map((evento) => ({
          name: evento.evento?.legenda,
          descricao: evento.descricao,
          id: evento.id,
          evento_id: evento.evento_id,
          start: evento.start,
          end: evento.end,
          color: evento.color,
        }));
      } catch (error) {
        this.$handleError(error);
      }
    },

    async loadEventos() {
      try {
        this.$loaderService.open("Carregando Eventos");
        const data = await this.$services.eventoCalendarioLetivoService.syncAll();

        this.eventosList = data.map((evento) => ({
          id: evento.id ?? null,
          text: evento.legenda ?? "Evento sem nome",
          value: evento.id ?? null,
          cor: evento.cor ?? null,
        }));
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    abrirModalVisualizacao(evento) {
      this.modalAberto = false;
      this.editando = false;
      this.modalConfirmacaoAberto = false;
      this.modalVisualizarAberto = false;
      this.eventoSelecionado = evento.event;
      this.modalVisualizarAberto = true;
    },
  },
};
</script>

<style scoped>
.v-sheet {
  border: 1px solid #ddd;
  border-radius: 8px;
}
.calendario-fixo {
  min-height: 400px;
  max-height: 400px;
  overflow: hidden;
}
</style>
